function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_10643_146954)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 4L8 3L16 4V12L8 13L0 12V4Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0H16V4H0V0ZM0 12H16V16H0V12Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 9.5H4V7H4.5V9.5ZM8.5 9.5H9V7H8.5V9.5Z",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 10.25C7.32843 10.25 8 9.80228 8 9.25C8 8.69772 7.32843 8.25 6.5 8.25C5.67157 8.25 5 8.69772 5 9.25C5 9.80228 5.67157 10.25 6.5 10.25Z",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 6.25C4.5 6.11193 4.38807 6 4.25 6C4.11193 6 4 6.11193 4 6.25V6.5C4 6.63807 4.11193 6.75 4.25 6.75C4.38807 6.75 4.5 6.63807 4.5 6.5V6.25Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 6.25C9 6.11193 8.88807 6 8.75 6C8.61193 6 8.5 6.11193 8.5 6.25V6.5C8.5 6.63807 8.61193 6.75 8.75 6.75C8.88807 6.75 9 6.63807 9 6.5V6.25Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8.5V9.25C6.5 9.44891 6.57902 9.63968 6.71967 9.78033C6.86032 9.92098 7.05109 10 7.25 10C7.44891 10 7.63968 9.92098 7.78033 9.78033C7.92098 9.63968 8 9.44891 8 9.25V8.5H7.25H6.5Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 6.5H4C3.86193 6.5 3.75 6.61193 3.75 6.75C3.75 6.88807 3.86193 7 4 7H4.5C4.63807 7 4.75 6.88807 4.75 6.75C4.75 6.61193 4.63807 6.5 4.5 6.5Z",
  fill: "#FF9811"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 6.5H8.5C8.36193 6.5 8.25 6.61193 8.25 6.75C8.25 6.88807 8.36193 7 8.5 7H9C9.13807 7 9.25 6.88807 9.25 6.75C9.25 6.61193 9.13807 6.5 9 6.5Z",
  fill: "#FF9811"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 9.5H4C3.86193 9.5 3.75 9.61193 3.75 9.75C3.75 9.88807 3.86193 10 4 10H4.5C4.63807 10 4.75 9.88807 4.75 9.75C4.75 9.61193 4.63807 9.5 4.5 9.5Z",
  fill: "#FF9811"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 9.5H8.5C8.36193 9.5 8.25 9.61193 8.25 9.75C8.25 9.88807 8.36193 10 8.5 10H9C9.13807 10 9.25 9.88807 9.25 9.75C9.25 9.61193 9.13807 9.5 9 9.5Z",
  fill: "#FF9811"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 8.5V9.25C5 9.5 5.125 9.6875 5.28125 9.84375L5.4375 9.65625L5.59375 9.96875C5.6964 9.99391 5.8036 9.99391 5.90625 9.96875L6.0625 9.65625L6.21875 9.84375C6.40625 9.6875 6.5 9.5 6.5 9.25V8.5H6.21875L6.0625 8.75L5.90625 8.5H5.59375L5.4375 8.75L5.28125 8.5H5Z",
  fill: "#FF9811"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.8125 7.75C3.77935 7.75 3.74755 7.76317 3.72411 7.78661C3.70067 7.81005 3.6875 7.84185 3.6875 7.875C3.6875 7.90815 3.70067 7.93995 3.72411 7.96339C3.74755 7.98683 3.77935 8 3.8125 8H9.1875C9.22065 8 9.25245 7.98683 9.27589 7.96339C9.29933 7.93995 9.3125 7.90815 9.3125 7.875C9.3125 7.84185 9.29933 7.81005 9.27589 7.78661C9.25245 7.76317 9.22065 7.75 9.1875 7.75H3.8125ZM3.8125 8.5C3.77935 8.5 3.74755 8.51317 3.72411 8.53661C3.70067 8.56005 3.6875 8.59185 3.6875 8.625C3.6875 8.65815 3.70067 8.68995 3.72411 8.71339C3.74755 8.73683 3.77935 8.75 3.8125 8.75H4.6875C4.72065 8.75 4.75245 8.73683 4.77589 8.71339C4.79933 8.68995 4.8125 8.65815 4.8125 8.625C4.8125 8.59185 4.79933 8.56005 4.77589 8.53661C4.75245 8.51317 4.72065 8.5 4.6875 8.5H3.8125ZM8.3125 8.5C8.27935 8.5 8.24755 8.51317 8.22411 8.53661C8.20067 8.56005 8.1875 8.59185 8.1875 8.625C8.1875 8.65815 8.20067 8.68995 8.22411 8.71339C8.24755 8.73683 8.27935 8.75 8.3125 8.75H9.1875C9.22065 8.75 9.25245 8.73683 9.27589 8.71339C9.29933 8.68995 9.3125 8.65815 9.3125 8.625C9.3125 8.59185 9.29933 8.56005 9.27589 8.53661C9.25245 8.51317 9.22065 8.5 9.1875 8.5H8.3125Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.125 5.25C5.90625 5.25 5.71875 5.40625 5.65625 5.59375L5.5 5.5625C5.21875 5.5625 5 5.78125 5 6.0625C5 6.34375 5.21875 6.5625 5.5 6.5625C5.71875 6.5625 5.90625 6.4375 5.96875 6.21875C6.05989 6.25163 6.15862 6.25732 6.25293 6.23512C6.34725 6.21293 6.43308 6.16382 6.5 6.09375C6.56692 6.16382 6.65275 6.21293 6.74707 6.23512C6.84138 6.25732 6.94011 6.25163 7.03125 6.21875C7.06157 6.3134 7.11942 6.39687 7.19739 6.45849C7.27537 6.52012 7.36995 6.55711 7.46905 6.56473C7.56814 6.57236 7.66726 6.55028 7.75375 6.50131C7.84024 6.45234 7.91018 6.37871 7.95463 6.28981C7.99907 6.20092 8.01602 6.10079 8.0033 6.00222C7.99058 5.90364 7.94877 5.8111 7.88321 5.7364C7.81765 5.6617 7.73132 5.60823 7.63523 5.58282C7.53914 5.55741 7.43766 5.56122 7.34375 5.59375C7.31361 5.51273 7.26298 5.44091 7.19681 5.3853C7.13063 5.32968 7.05117 5.29218 6.96617 5.27644C6.88117 5.2607 6.79355 5.26726 6.71184 5.29549C6.63014 5.32372 6.55715 5.37265 6.5 5.4375C6.40625 5.3125 6.28125 5.25 6.125 5.25ZM6.125 5.5C6.28125 5.5 6.375 5.625 6.375 5.75C6.375 5.90625 6.28125 6 6.125 6C6 6 5.875 5.90625 5.875 5.75C5.875 5.625 6 5.5 6.125 5.5ZM6.875 5.5C7.03125 5.5 7.125 5.625 7.125 5.75C7.125 5.90625 7.03125 6 6.875 6C6.75 6 6.625 5.90625 6.625 5.75C6.625 5.625 6.75 5.5 6.875 5.5ZM5.5 5.8125L5.625 5.84375L5.75 6.09375C5.75 6.21875 5.625 6.3125 5.5 6.3125C5.375 6.3125 5.25 6.21875 5.25 6.0625C5.25 5.9375 5.375 5.8125 5.5 5.8125ZM7.5 5.8125C7.65625 5.8125 7.75 5.9375 7.75 6.0625C7.75 6.21875 7.65625 6.3125 7.5 6.3125C7.375 6.3125 7.25 6.21875 7.25 6.09375L7.375 5.84375L7.5 5.8125Z",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.25 5H6.75V6H6.25V5Z",
  fill: "#FF9811"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 7H8V8.5H6.5V7Z",
  fill: "#EEEEEE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.75 6.5L7.5 6.75H5.5L5.25 6.5C5.25 6.09375 5.8125 5.75 6.5 5.75C7.1875 5.75 7.75 6.09375 7.75 6.5ZM5 7H6.5V8.5H5V7Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5625 7.5625C7.5625 7.38991 7.42259 7.25 7.25 7.25C7.07741 7.25 6.9375 7.38991 6.9375 7.5625V7.9375C6.9375 8.11009 7.07741 8.25 7.25 8.25C7.42259 8.25 7.5625 8.11009 7.5625 7.9375V7.5625Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.25 7.25V7.5H5.5V8H5.25V8.25H6.25V8H6V7.5H6.25V7.25H5.25ZM5.5 6.75H7.5V7H5.5V6.75Z",
  fill: "#FF9811"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.8125 6.5C5.91605 6.5 6 6.41605 6 6.3125C6 6.20895 5.91605 6.125 5.8125 6.125C5.70895 6.125 5.625 6.20895 5.625 6.3125C5.625 6.41605 5.70895 6.5 5.8125 6.5Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 6.5C6.60355 6.5 6.6875 6.41605 6.6875 6.3125C6.6875 6.20895 6.60355 6.125 6.5 6.125C6.39645 6.125 6.3125 6.20895 6.3125 6.3125C6.3125 6.41605 6.39645 6.5 6.5 6.5Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.1875 6.5C7.29105 6.5 7.375 6.41605 7.375 6.3125C7.375 6.20895 7.29105 6.125 7.1875 6.125C7.08395 6.125 7 6.20895 7 6.3125C7 6.41605 7.08395 6.5 7.1875 6.5Z",
  fill: "#FFDA44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.28125 8.5V9.84375C5.3746 9.90855 5.48146 9.9513 5.59375 9.96875V8.5H5.28125ZM5.90625 8.5V9.96875C6.01854 9.9513 6.1254 9.90855 6.21875 9.84375V8.5H5.90625Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 9C6.77614 9 7 8.77614 7 8.5C7 8.22386 6.77614 8 6.5 8C6.22386 8 6 8.22386 6 8.5C6 8.77614 6.22386 9 6.5 9Z",
  fill: "#338AF3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 10H8.5C8.36193 10 8.25 10.1119 8.25 10.25C8.25 10.3881 8.36193 10.5 8.5 10.5H9C9.13807 10.5 9.25 10.3881 9.25 10.25C9.25 10.1119 9.13807 10 9 10Z",
  fill: "#338AF3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.5 10H4C3.86193 10 3.75 10.1119 3.75 10.25C3.75 10.3881 3.86193 10.5 4 10.5H4.5C4.63807 10.5 4.75 10.3881 4.75 10.25C4.75 10.1119 4.63807 10 4.5 10Z",
  fill: "#338AF3"
}));

function SvgEs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10643_146954",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.12f161ab.svg";
export { ForwardRef as ReactComponent };